// import { FormControl, MenuItem, Select } from "@mui/material";
import dayjs from "dayjs";
import Select, { components, SingleValueProps } from 'react-select';

import { t } from "i18next";
import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { getLocal } from "../helper/helper";
import { colorTurquoise60 } from "../rsc/colors/colors";

type Props = {
    color: string
}

type MenuType = {
    label: string,
    value: string
}

export const SwitchLang: React.FC<Props> = ({ color }) => {

    const profileMenu: MenuType[] = [
        { label: t('English'), value: 'en-US' },
        { label: t('Indonesian'), value: "id" }
    ]

    const { i18n } = useTranslation();

    const [value, setValue] = useState<MenuType>(profileMenu.find(o => o.value === getLocal()))

    const changeLanguage = (value) => {
        localStorage.setItem('lang', value)
        dayjs.locale(value)
        i18n.changeLanguage(value)
    }

    const options = useMemo(() => {
        return profileMenu.map(o => o);
    }, []);

    const onOptionClick = (o: MenuType) => {
        setValue(o)
        changeLanguage(o.value)
    }

    const CustomSingleValue: React.FC<SingleValueProps<{ value: string; label: string | number }>> = (props) => {
        return (
            <components.SingleValue {...props}>
                <div className="gap5" style={{ display: 'flex', alignItems: 'center' }}>
                    <div style={{
                        width: 26,
                        height: 26,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: 12,
                    }}>
                    </div>
                    <span style={{ fontWeight: 600, color: color }}>{props.data.label}</span>
                </div>
            </components.SingleValue>
        );
    };

    return <div className="pointer" style={{ width: '150px', cursor: 'pointer !important' }}>
        <Select
            value={value}
            menuPortalTarget={document.body}
            menuPosition="fixed"
            isSearchable={false}
            styles={{
                input: (base) => ({ ...base, ':active': { borderColor: '#fff' }, color: "white", fontWeight: 600 }),
                singleValue: (base) => ({ ...base, ':active': { borderColor: '#fff' }, color: "#fff", fontWeight: 600 }),
                menuPortal: base => ({ ...base, ':active': { borderColor: '#fff' }, zIndex: 9999 }),
                menu: base => ({
                    ...base,
                    backgroundColor: 'var(--color-bg)',
                    border: '1px solid var(--color-border)',
                    borderRadius: 10,
                    overflow: 'hidden',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                }),
                menuList: base => ({
                    ...base,
                    padding: 0,
                }),
                option: (base, state) => ({
                    ...base,
                    backgroundColor: state.isSelected
                        ? colorTurquoise60()
                        : state.isFocused
                            ? 'var(--color-surface-alt)'
                            : 'transparent',
                    color: state.isSelected ? '#fff' : 'var(--color-text)',
                    padding: '12px 16px',
                    cursor: 'pointer',
                    fontWeight: state.isSelected ? 600 : 400,
                    ':active': {
                        backgroundColor: colorTurquoise60(),
                        color: '#fff',
                    },
                }),
                container: base => ({ ...base, width: '100%', minHeigh: 0, padding: 0, borderRadius: 18 }),
                indicatorsContainer: base => ({
                    ...base,
                    ':active': { borderColor: '#fff' },
                }),
                control: (base, state) => (
                    {
                        ...base,
                        border: `none`,
                        background: 'transparent',
                        ':hover': {
                            borderColor: 'none',
                            boxShadow: 'none',
                            background: 'none'
                        }
                    }),
                dropdownIndicator: (base) => ({
                    ...base,
                    color: color,          // base color
                    ':hover': { color: '#fff' }, // keep same on hover
                    ':active': { color: '#fff' },
                    svg: { width: 18, height: 18 }
                })
            }}
            components={{
                IndicatorSeparator: () => null,
                SingleValue: CustomSingleValue
            }}
            onChange={opt => { onOptionClick(opt ? (opt as any) : undefined) }}
            options={options}
            isClearable={false}
        />
    </div>
}